import { getRoleList } from '@/api/authority';
import createModal from '@/components/SetRole';
import commonStore from '@/store/common';
import { NO_ROLE } from '@/type/auth';
import { getQueryVariable } from '@/utils/http';
import { Modal } from 'ant-design-vue';
import { loginUrl } from '../api/fetch';
import { getLogoutUrl, verify } from '../api/login';
import { ResCurrentUser } from '../type/user';

export interface IUserInfoState {
  isLoginStatus: boolean;
  userInfo?: ResCurrentUser;
}

export interface LoginTools {
  setLoginStatus: (status: boolean) => void;
  getUserInfo: () => Promise<object | undefined>;
  toLoginOut: () => void;
}

/**
 * 登录并获取用户信息hooks
 * @function
 * @params {IUserInfoState} userState 用户信息
 * @returns store extend LoginTools
 */
export const useLoginProvide: () => LoginTools = () => {
  const common = commonStore();

  // 登录并获取用户信息
  const getUserInfo = async () => {
    // 获取集团登录传递的token
    const token = getQueryVariable('token') || '';
    const res = await verify(token);
    // res.code = NO_ROLE; // TODO：需要删除
    if (res.code !== 0 && res.code !== NO_ROLE) {
      Modal.info({
        title: '温馨提示',
        content: res.msg,
        onOk: () => {
          toLoginOut();
        }
      });
      return null;
    } else if (res.code === NO_ROLE) {
      // 没有角色，选择角色
      const { data } = await getRoleList();
      const roleList = data?.roleList;
      await createModal(roleList);
      return null;
    } else {
      res.data['teacherId'] = res.data?.teacher_id;
      return res.data;
    }
  };

  // 设置登录状态
  const setLoginStatus = (status: boolean) => {
    common.hasLogin = status;
  };

  // 退出登录并跳转集团登录页
  const toLoginOut = async () => {
    // 调用后端退出登录接口
    const res = await getLogoutUrl();

    localStorage.removeItem('userInfo');
    localStorage.removeItem('hasLogin');
    localStorage.removeItem('Teacher-Desk-X-BRAND'); // 清空选中的品牌
    // 重定向到集团登录页面
    window.location.href = 'https://sso.saash.vdyoo.com/sso/logout?path=' + loginUrl;
  };

  return {
    setLoginStatus,
    toLoginOut,
    getUserInfo
  };
};
